import axios from 'axios'
import Vue from 'vue'
import Cookies from 'js-cookie'
import { Encrypt } from '@/utils/crypto.js'
import { Message,MessageBox } from 'element-ui'
import { isEmptyOrNull } from '@/utils/index'
import md5 from 'js-md5'
import store from '@/store/index'
import {loginOut} from '@/utils/auth'
Vue.prototype.axios = axios

// 创建axios实例
axios.defaults.timeout = 60000 // 响应时间
axios.defaults.withCredentials = true
axios.defaults.baseURL = process.env.BASE_API
// @requestParams
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'

var secret = process.env.SECRET

// request拦截器
axios.interceptors.request.use(config => {
    // 每次请求参数拿最新的timestamp
    // config.headers.timestamp = Encrypt(time)
    // config.headers.sign = Encrypt(sign)
    return config
}, error => {
    // loadinginstace.close()
    Message.error({
        message: '加载超时'
    })
    // console.log(error) // for debug
    Promise.reject(error)
})
// respone拦截器
axios.interceptors.response.use(
    response => {
        switch (response.data.code) {
            case '32':
                loginOut();
                /* MessageBox.alert('登录已失效，请重新登录', '错误', {
                    confirmButtonText: '确定',
                    type : 'error',
                    callback: action => {
                      window.location.href="/passport/login"
                    }
                  }) */
                break;
            default:
                break;
        }
        // loadinginstace.close()
        return response
    },
    error => {
        // console.log('err' + error)// for debug
        // loadinginstace.close()
        // Message.error({
        //   message: '加载失败'
        // })
        return Promise.reject(error)
    })
// export default axios
// 返回一个Promise(发送post请求)
export function postFetch(url, queryParam, bodyParams) {
    // userName = 'test9986'
    // token = 'c39edeb0-f3ce-44fb-86dc-cd4e7796616e'
    // Cookies.set('_n', userName)
    // Cookies.set('_ct', token)
    var loginParam = getLoginParam();
    // 构建url参数
    if (queryParam && queryParam != {}) {
        url = url + "?"
        for (const key in queryParam) {
          url = url + key + "=" + queryParam[key] + "&"
        }
    }
    if (url.indexOf("?") > -1) {
        url = url.substring(0, url.length - 1)
    }

    var paramsAes = Object.assign({}, loginParam, bodyParams)
    return new Promise((resolve, reject) => {
        axios.post(url, paramsAes)
            .then(response => {
                resolve(response.data)
            }, err => {
                reject(err)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

// export default axios
// 返回一个Promise(发送get请求)
export function getFetch(url, params) {
    // userName = 'test9986'
    // token = 'c39edeb0-f3ce-44fb-86dc-cd4e7796616e'
    // Cookies.set('_n', userName)
    // Cookies.set('_ct', token)
    var loginParam = getLoginParam();
    var paramsAes = Object.assign({}, loginParam, params)
    return new Promise((resolve, reject) => {
        axios.get(url, { params: paramsAes })
            .then(response => {
                resolve(response.data)
            }, err => {
                reject(err)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export function getLoginParam() {
    let userName = store.getters.getUserName
    let token = store.getters.getToken
    let loginParam = {};
    loginParam.username = Encrypt(userName)
    loginParam.token = Encrypt(token)
    // time = getServerDate()
    let time = new Date().getTime()
    let sign = md5(secret + 'timestamp' + time + 'token' + token + 'username' + userName + secret)
    loginParam.timestamp = Encrypt(time)
    loginParam.sign = Encrypt(sign)
    return loginParam;
}


// WEBPACK FOOTER //
// ./src/utils/request.js